const colors = {
    white: '#FFFFFF',
    black: '#000000',
    gray: '#f6f6f6',
    lightGray: '#787878',
    lighterGray: '#FAFAFA',
    red: '#c63428',
    mediumDarkBlue: '#34657f',
    mediumLightBlue: '#9ab2bf',
    lightBlue: 'f0f3f5 ',
    turquoise: '#f1f8f8'
};
export default colors;
